define('lib/view/mixin/IntlPhone',['require','Config'],function (require) {

    var Config = require('Config');

    //per-field debounce timers, keyed by the actual DOM element — a single shared
    //window.intlPhoneTimer here meant any two phone fields calling showIntlPhone within
    //500ms of each other would cancel one another, silently leaving one of them
    //uninitialized (no flag/country dropdown at all)
    var intlPhoneTimers = new WeakMap();

    return {

        showIntlPhone: function (visibleInputSelector, options ) {
            var _this = this;

            if(!options || !_.isObject(options)){
                options = {};
            }

            var el = jQuery(visibleInputSelector)[0];
            if(!el){
                console.log('unkown phone field');
                return;
            }

            clearTimeout(intlPhoneTimers.get(el));
            intlPhoneTimers.set(el, setTimeout(function () {
                if (visibleInputSelector && visibleInputSelector.closest(document).length) {
                    _this._showIntlPhone(visibleInputSelector, options);
                } else{
                    console.log('unkown phone field');
                }
            }, 500));
        },

        _getReqiredFields : function(){;
            if(!this.requiredFields){
                this.requiredFields =  Config.getInstance().getOption('require_fields');
                if (!this.requiredFields) {
                    this.requiredFields =  Config.getInstance().getOption('client_require_fields');
                }
            }
            return this.requiredFields;
        },

        _isFieldRequired : function(field){
            var requiredFields = this._getReqiredFields();
            if(!requiredFields){
                return false;
            }
            return requiredFields && field && requiredFields.indexOf(field) >= 0;
        },

        _showIntlPhone: function (visibleInputSelector, options ) {
            if(jQuery(visibleInputSelector).length){

                this._preparePhone(visibleInputSelector, options);

                this._initGenerator();

                var $hiddenInp = jQuery(visibleInputSelector);
                var $visibleInp = $hiddenInp.clone();

                $visibleInp.insertAfter($hiddenInp);
                $visibleInp.attr('id', idGen.getId()).attr('name', idGen.getId());

                $hiddenInp.css({
                    'width' : '0px',
                    'height' : '0px',
                    'padding' : '0px',
                    'margin' : '0px',
                    'position' : 'absolute',
                    'border' : 'none',
                });

                this._initIntl($visibleInp, $hiddenInp, options);

            } else{
                console.warn('Unknown input');
            }
        },

        _initIntl: function (visibleInputSelector, hiddenInputSelector, options ) {
            if(jQuery(visibleInputSelector).length){
                var id = jQuery(visibleInputSelector).attr('id');

                if(!id){
                    this._initGenerator();
                    id = window.idGen.getId();
                    jQuery(visibleInputSelector).attr('id', id);
                }

                var idHidden = jQuery(hiddenInputSelector).attr('id');
                id = '#'+ id;
                idHidden = idHidden?'#'+ idHidden:null;

                var companyCountry = null;
                var companyData = Config.getInstance().getOption('company');
                if(!companyData){
                    companyData = Config.getInstance().getOption('company_data');
                }
                if(companyData){
                    companyCountry = companyData.country_id;
                }
                var initialCountry = Config.getInstance().getOption('country_phone_initial');

                if(!initialCountry && companyCountry){
                    initialCountry = String(companyCountry).toLowerCase();
                }

                this.phoneInput = new IntlInitializer(id, idHidden, jQuery.extend({
                    initialCountry : initialCountry,
                    hiddenInput: idHidden,
                    showError : false,
                    showErrorBorder : false,
                    numberDisplayFormat: 'NATIONAL',
                    required: this._isFieldRequired('phone'),
                    errorTemplate: "<div class=\"errors\"> <div class=\"invalid-feedback\">{{error}}</div> </div>",
                    //without this, the hidden input (which the model/save flow actually reads)
                    //only gets the visible field's value on 'change'/'countrychange' — i.e. on
                    //blur. Clicking Save moves focus off the phone field first, which normally
                    //fires blur+change before the click handler reads the model, but this timing
                    //isn't reliable in Safari specifically: reproduced there as a phone field
                    //that visually shows a valid, fully-typed number yet saves with the
                    //"required"/empty error, because the hidden input's value was still stale
                    //when validation ran. Syncing on every keyup removes the dependency on
                    //blur firing before save reads the value.
                    triggerChangeHidden: true
                }, options));
            } else{
                console.warn('Unknown input');
            }
        },

        _preparePhone : function(visibleInputSelector, options){
            var $inp = jQuery(visibleInputSelector);

            if($inp && $inp.length){
                var number = String($inp.val()).trim();

                if(number){
                    var fChar = number.charAt(0);

                    if(fChar !== '+' && fChar !== '0'){
                        number = '+' + number;
                        $inp.val(number).trigger('change');
                    }
                }
            }
        },

        _initGenerator : function () {
            if(!window.Generator) {
                window.Generator = function () {
                };
                window.Generator.prototype.rand = Math.floor(Math.random() * 26) + Date.now();
                window.Generator.prototype.getId = function () {
                    this.rand++;
                    return 'p' + this.rand;
                };
                window.idGen = new Generator();
            }
        },

    };

});

